import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ExternalLoansDashboardStore } from '../stores/externalLoansDashboardStore';
import { ForeclosureInvoiceStore } from '../stores/foreclosureInvoiceStore';
import { InvoicesDashboardStore } from '../stores/invoicesDashboardStore';
import { VendorCompanyProfileStore } from '../stores/vendorCompanyProfileStore';
import { VendorBankInformationStore } from '../stores/vendorBankInformationStore';

export const useExternalAgentLoansStore = () =>
  useContext<{
    foreclosureInvoiceStore: ForeclosureInvoiceStore;
    externalLoansDashboardStore: ExternalLoansDashboardStore;
    invoicesDashboardStore: InvoicesDashboardStore;
    vendorCompanyProfileStore: VendorCompanyProfileStore
  }>(StoreContext);
